import { FC, useEffect, useRef, useState } from 'react';
import { Spin } from 'antd';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import { useSelector } from 'react-redux';
import {
  ControlType,
  parseValueCatch,
  relevancyShow,
  setComValue,
} from '@/common/components/business/DynamicComponent/config';
import {
  addressChangeCommon,
  handleFootprintTextValue,
} from '@/common/components/business/DynamicComponent/customize';
import styles from './index.module.less';
import V2Form from '@/common/components/Form/V2Form';
import DynamicComponent from '@/common/components/business/DynamicComponent';
import RecoupCostPeriod from './RecoupCostPeriod';
import { AddressChangeParams } from '@/common/components/business/DynamicComponent/components/Address';
import { useBigdataFn } from '@/common/utils/bigdata';
import EstimateSalesKWK from './EstimateSalesKWK';
import { applyYiMingChanceFieldRules, handleYiMingChanceFieldClear } from '@/common/components/business/DynamicComponent/yiMingChancepoint';

/**
 * @Description 机会点form内容
 */
const Main: FC<{
  formData,
  tabs,
  topRef,
  tabActiveRef,
  tabContentRefs,
  active,
  /** 设置tab选中项 */
  setTabActive,
  // scrollAccordingTab: boolean,
  isLongList: boolean,
  form,
  /** 所有组件字段平铺后的对象数组；使用 formDataComsToTiled 将动态表单中的所有组件平铺到数组中，方便查找到对应的组件 */
  tiledFormDataRef,
  setFormData,
  mainHeight?,
  /** 是否传统的点位评估编辑页（不包含一鸣等租户走机会点点位评估审批流的场景），是的话item的显示、禁用，参照的是机会点拓店模板、非流程设置 */
  isTraditionEvaluation: boolean,
  /** 表单是否检查必填项，true检查，false只检查特定identification必填字段 */
  // needCheck = true,
  supportDirectApproval,
  /** 在编辑状态下，踩点组件是否已有数据（已有数据则设置表单不可读） */
  isFootprintValue,
  /** 是否有区域保护 */
  isAreaProtect,
  /** 计算公式 */
  computationalLogic,
  /** 拓店任务商圈id */
  expansionTaskClusterId?,
  /** 是否编辑 */
  isEdit,
  /** 加盟商来源已完成地址初始化，避免地址组件挂载时重复触发。 */
  franchiseePrefill?: boolean,
  /** 来源模板和地址初始化期间仅阻止内容编辑，不改变容器高度契约。 */
  prefillLoading?: boolean,
  /** 来源已带入名称时，地址联动不能覆盖。 */
  preservePrefilledName?: boolean,
  /** 已有地址联动异步返回的商圈状态。 */
  prefillAddressState?: any,
  /** 手动地址变更后停用来源初始化的后台回写。 */
  onManualAddressChange?: () => void,
}> = ({
  formData,
  tabs,
  topRef,
  tabActiveRef,
  tabContentRefs,
  active,
  setTabActive, // 设置tab选中项
  // scrollAccordingTab = false,
  isLongList = false,
  form,
  tiledFormDataRef,
  setFormData,
  mainHeight,
  isTraditionEvaluation = false, // 是否点位评估表单，是的话字段参照拓店模板设置，而不是流程配置
  // needCheck = true, // 表单是否检查必填项，true检查，false只检查特定identification必填字段
  supportDirectApproval,
  isFootprintValue, // 在编辑状态下，踩点组件是否已有数据（已有数据则设置表单不可读）
  isAreaProtect, // 是否有区域保护
  computationalLogic, // 计算公式
  expansionTaskClusterId,
  isEdit,
  franchiseePrefill,
  prefillLoading,
  preservePrefilledName,
  prefillAddressState,
  onManualAddressChange,
}) => {

  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const isYiMing = !!useSelector((state: any) => state.common.tenantCheck?.isYiMing);
  const selfRef: any = useRef();
  const topHeight: number = (topRef?.current?.getBoundingClientRect()?.height || 0) + 24;
  const returnPeriodRef: any = useRef();
  const [businessPlanValue, setBusinessPlanValue] = useState({});
  const [businessInfoValue, setBusinessInfoValue] = useState({});
  const [addressVal, setAddressVal] = useState<any>(); // 地址组件的值
  const [salesFactorOfKWK, setSalesFactorOfKWK] = useState<any>({}); // 卡旺卡预计销售额影响因子，这里默认值设置为空对象：只有触发选择时才赋值
  const [isEditedBasicChancePointName, setEditedBasicChancePointName] = useState(false); // 定制化字段，机会点名称，用于判断是否编辑过
  const [sourceNameManuallyEdited, setSourceNameManuallyEdited] = useState(false);
  // 益禾堂定制组件-人口流量获取匹配商圈中的集客点的商圈类型
  const [customGatheringCategoryForYHT, setCustomGatheringCategoryForYHT] = useState<any>(null);
  useEffect(() => {
    if (prefillAddressState?.businessPlanValue) setBusinessPlanValue(prefillAddressState.businessPlanValue);
    if (prefillAddressState?.businessInfoValue) setBusinessInfoValue(prefillAddressState.businessInfoValue);
  }, [prefillAddressState]);
  useEffect(() => {
    if (prefillLoading) setSourceNameManuallyEdited(false);
  }, [prefillLoading]);
  // useEffect(() => {
  //   // 长列表时定位到具体group模块，不执行这块处理
  //   if (isLongList) return;

  //   if (!active) return;
  //   const targetDom = selfRef.current;
  //   if (!targetDom) return;
  //   targetDom.scrollTo({
  //     top: 0,
  //     behavior: 'smooth'
  //   });
  // }, [active]);

  useEffect(() => {
    // 如果是显示/隐藏状态的tab交互时
    if (!isLongList) return;
    if (!selfRef.current) return;
    selfRef.current.addEventListener('scroll', handleScroll);
    return () => selfRef.current && (selfRef.current.removeEventListener('scroll', handleScroll));
  }, []);
  const {
    onValuesChange,
    addressChange,
    updateRelateShow,
    updateCompValue,
    handleScroll,
    getTabContentRefs,
    isBottomOut,
    mapMoveChange,
    mapZoomChange
  } = useMethods({
    /**
     * 字段值更新时触发回调事件
     * @param changedFields 当前更新的字段值，格式为{ name: value } // name为表单项的name值，value是当前的值
     */
    onValuesChange(changedFields: any) {
      if (franchiseePrefill && Object.prototype.hasOwnProperty.call(changedFields || {}, 'basicChancePointName')) {
        setSourceNameManuallyEdited(true);
      }
      if (changedFields?.basicAddress) {
        bigdataFn('7a0665ae-faa4-48fb-b2d8-e1f5d3169bf5', '创建机会点-具体地址搜索', '创建机会点-具体地址搜索', { op_block: '创建机会点', op_event: ``, });
      }
      const curChangedFields = Object.entries(changedFields);
      if (!(isArray(curChangedFields) && curChangedFields.length)) return;
      const targetIdentification = curChangedFields[0][0];
      const val = curChangedFields[0][1];

      handleFootprintTextValue(tiledFormDataRef, targetIdentification, val);
      // 不同二级菜单下可添加相同字段之后，需要把find改成filter
      // const targetCom = tiledFormDataRef.current.find((item: any) => item.identification === targetIdentification);
      // setComValue(targetCom, val);
      // updateRelateShow(targetCom);
      const targetComs = tiledFormDataRef.current.filter((item: any) => item.identification === targetIdentification);
      if (!(isArray(targetComs) && targetComs.length)) return;
      let isNumberInput = false; // 是否是数字输入框组件
      targetComs.forEach((targetCom: any, index: number) => {
        // 竞品组件、品牌组件通过组件回调事件更新
        if ([
          ControlType.CONTEND_INFO.value,
          ControlType.COMPETITIVE_CONDITIONS.value,
          ControlType.BENCH_MARKING_BRANDS.value,
          ControlType.ESTIMATE_SALES_YHT.value, // 定制组件-益禾堂预估销售额2.0
          // 商务条件：内部字段经组件回调整体更新，不走 onValuesChange 部分覆盖
          ControlType.BUSINESS_CONDITION.value,
          // 项目点位选择以完整对象更新，不能用子字段覆盖。
          ControlType.PROJECT_SPOT_SELECT.value,
          ControlType.PROFIT_CAlCULATION_JNP.value].includes(targetCom.controlType)) {
          return;
        }
        setComValue(targetCom, val);
        const { controlType } = targetCom;
        // 相同的字段，其组件类型一定是相同的
        isNumberInput = controlType === ControlType.INPUT_NUMBER.value;
        if (index > 0) return;
        updateRelateShow(targetCom); // 只执行一次
      });
      // 只有数字输入框组件或加盟费-益禾堂（下拉框）才能配置计算公式
      const shouldRunCommonCalculation = isNumberInput || targetIdentification === 'franchiseFeeYHT';
      if (shouldRunCommonCalculation) computationalLogic();
      if (isYiMing) applyYiMingChanceFieldRules({ form, tiledFormData: tiledFormDataRef.current });
      if (!shouldRunCommonCalculation) return;
      // 回本周期定制化逻辑
      returnPeriodRef.current.valuesChange(targetIdentification, val);
    },

    /**
     * @description 字段值变动时，刷新关联组件展示
     * @param targetCom 发生字段值变动的属性
     */
    updateRelateShow(targetCom) {
      if (!targetCom) return;
      if (isYiMing) handleYiMingChanceFieldClear({ form, tiledFormData: tiledFormDataRef.current, identification: targetCom.identification });
      // 配置了关联显示的字段时，如果重新渲染
      // const { templateRestriction } = targetCom;
      const targetConfig = parseValueCatch(targetCom, 'templateRestriction');
      if (!targetConfig) return;
      const { activeLinkageRelations } = targetConfig;
      if (isArray(activeLinkageRelations) && activeLinkageRelations.length) {
        const defaultValues = relevancyShow(tiledFormDataRef.current, true);
        Object.keys(defaultValues).length && form.setFieldsValue(defaultValues);
        // 关联显隐会清空隐藏字段并恢复重新显示字段的默认值，完成后重算依赖字段。
        computationalLogic();
        setFormData((state) => ({ ...state, ...formData }));
      }
    },
    /**
     * 详细地址组件的特殊逻辑
     * 通过高德的逆地址解析拿到高德的code，通过接口查找对应的省市区id，然后赋值到省市区组件上（addressChangeCommon 函数触发）
     */
    async addressChange(params: AddressChangeParams) {
      if (franchiseePrefill) {
        if (params.isInitChange || !params.lng || !params.lat) return;
        onManualAddressChange?.();
      }
      setAddressVal(params);
      addressChangeCommon(params, tiledFormDataRef, form, (compValue) => {
        // 将商圈规划数据传入组件
        setBusinessPlanValue(compValue);
      }, (compValue) => {
        // 将商圈信息数据传入组件
        setBusinessInfoValue(compValue);
      });

      // 目前只在手动变更地址时触发计算公式、编辑回显获取地址时不执行
      if (!params.isInitChange) {
        // 日均销售额预测参与了写死的计算公式[回本周期]的计算，动态赋值之后需要再触发一次计算公式计算
        computationalLogic();
        // 查找一次试算单店月均盈余值
        returnPeriodRef.current?.valuesChange?.('', '');
      }
    },

    /**
     * @description 自定义组件（周边查询、商圈规划、周边竞品等）变动时，更新componentValue
     * @param params 通常为对象
     */
    updateCompValue(identification, params: any) {
      const targetCom = tiledFormDataRef.current.find((item: any) => item.identification === identification);
      setComValue(targetCom, params);
    },
    /**
     * 获取tab内容的dom元素
     * @param el 对应content的dom元素
     * @param index 对应一级菜单索引
     * @param id 对应一级菜单的id (key)
     */
    getTabContentRefs: (el: any, index: number, id: number) => {
      tabContentRefs.current[index] = {
        el,
        id
      };
    },
    // handleScroll: debounce(() => {
    handleScroll: () => {
      // 所有content此时距离顶部的距离，需要减去(吸顶部分的高度 + 抽屉上边距）
      const offsets = tabContentRefs.current.map((refItem) => refItem?.el?.getBoundingClientRect()?.top - topHeight);
      // 当前tab内容所处的索引
      const activeIndex = offsets.findIndex((offset, index) => {
        const nextOffset = offsets[index + 1] || 0;
        return offset <= 0 && nextOffset > 0;
      });
      // 当前点击tab时，查看当前点击的tab距离顶部的距离
      const targetIndex = tabContentRefs.current.findIndex((item) => item.id === +tabActiveRef.current);
      const targetOffset = targetIndex !== -1 ? offsets[targetIndex] : 0;
      if (activeIndex !== -1 && tabs[activeIndex]) {
        // 滚动条已经滚动到底，但是可视区域顶部还在其他tab内容区域下（最后的几个tab可能内容很少，出现在一屏）
        if (isBottomOut() && targetOffset > 0) {
          setTabActive(tabActiveRef.current);
          return;
        };
        const target = tabContentRefs.current[activeIndex];
        target && target.id && setTabActive && setTabActive(`${target.id}`);
      }
    // }, 50),
    },
    isBottomOut: () => {
      const scrollTop = selfRef.current.scrollTop;
      const scrollHeight = selfRef.current.scrollHeight;
      const clientHeight = selfRef.current.clientHeight || selfRef.current.innerHeight;
      return scrollTop + clientHeight >= scrollHeight;
    },
    mapMoveChange: () => {
      bigdataFn('25c9251e-22c6-4643-9a02-60f2dec0fa61', '创建机会点详情-地图拖动一次', '创建机会点详情-地图拖动一次', { op_block: '创建机会点', op_event: ``, });
    },
    mapZoomChange: () => {
      bigdataFn('9c28b016-4760-4f06-b20d-8354d10d302c', '创建机会点详情-地图放大/缩小一次', '创建机会点详情-地图放大/缩小一次', { op_block: '创建机会点', op_event: ``, });
    }
  });
  return (
    <>
      <div
        ref={selfRef}
        className={styles.mainCon}
        style={{
          height: `${mainHeight}px` || 'auto'
        }}>
        <Spin spinning={prefillLoading}>
          <V2Form
            form={form}
            onValuesChange={onValuesChange}
          >
            {
              formData?.propertyGroupVOList ? <>
                {
                // 遍历一级菜单
                  formData?.propertyGroupVOList.map((groupData: any, index) => (<div
                    key={index}
                    ref={(el) => getTabContentRefs(el, index, groupData.id)}
                  >
                    {
                      (isLongList || groupData.id === +active) ? <DynamicComponent
                        form={form}
                        wholeFormData={formData}
                        formData={groupData}
                        showAssociatedRecords
                        // active={active}
                        // scrollAccordingTab={scrollAccordingTab}
                        isTraditionEvaluation={isTraditionEvaluation}
                        // needCheck={needCheck}
                        isLongList={isLongList}
                        supportDirectApproval={supportDirectApproval}
                        addressChange={addressChange}
                        mapMoveChange={mapMoveChange}
                        mapZoomChange={mapZoomChange}
                        updateRelateShow={updateRelateShow}
                        isFootprintValue={isFootprintValue}
                        businessPlanValue={businessPlanValue}
                        businessInfoValue={businessInfoValue}
                        updateCompValue={updateCompValue}
                        isAreaProtect={isAreaProtect}
                        addressVal={addressVal}
                        salesFactorOfKWK={salesFactorOfKWK}
                        setSalesFactorOfKWK={setSalesFactorOfKWK}
                        isEditedBasicChancePointName={isEditedBasicChancePointName || !!preservePrefilledName || sourceNameManuallyEdited}
                        setEditedBasicChancePointName={setEditedBasicChancePointName}
                        tiledFormDataRef={tiledFormDataRef}
                        customGatheringCategoryForYHT={customGatheringCategoryForYHT}
                        setCustomGatheringCategoryForYHT={setCustomGatheringCategoryForYHT}
                        isEdit={isEdit}
                        expansionTaskClusterId={expansionTaskClusterId}
                      // expansionTaskId={expansionTaskId}
                      /> : null
                    }
                  </div>))
                }
              </>
                : null
            }
          </V2Form>
        </Spin>

        {/* 回本周期 */}
        <RecoupCostPeriod
          ref={returnPeriodRef}
          form={form}
          tiledFormDataRef={tiledFormDataRef}
          updateCompValue={updateCompValue}/>

        {/* 卡旺卡预计门店销售额 */}
        <EstimateSalesKWK
          form={form}
          addressVal={addressVal}
          businessInfoValue={businessInfoValue}
          salesFactorOfKWK={salesFactorOfKWK}
          tiledFormDataRef={tiledFormDataRef}
        />
      </div>
    </>
  );
};

export default Main;
